export default "__VITE_ASSET__D53Bg78e__"